import Image from "next/image";
import { MdOutlineClose } from "react-icons/md";
import { useTranslation } from "next-i18next";
import { useMobileDetect } from "@hooks/useMobileDetect";
import { Modal } from "@components/shared";

interface UserModalProps {
  userDetails?: {
    userId: number;
    userThumbnail: string;
    username: string;
  };
  isOpenUserModal: boolean;
  setIsOpenUserModal: (value: boolean) => void;
}

export const UserModal = ({
  userDetails,
  isOpenUserModal,
  setIsOpenUserModal,
}: UserModalProps) => {
  const { t: translate } = useTranslation();

  const { isAndroid } = useMobileDetect();

  const handleGetTheApp = () => {
    const playStoreUrl =
      "https://play.google.com/store/apps/details?id=com.bederapp";
    const appStoreUrl =
      "https://apps.apple.com/app/beder-l-explore-travel/id1609301338";

    const appUrl = isAndroid() ? playStoreUrl : appStoreUrl;

    window.open(appUrl, "_blank", "noreferrer");
  };

  const handleUserClose = (
    evt: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    evt.stopPropagation();
    setIsOpenUserModal(false);
  };

  const handleBackdropClick = (
    evt: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    evt.stopPropagation();
    setIsOpenUserModal(false);
  };

  return (
    <Modal isOpen={isOpenUserModal}>
      <div
        onClick={handleBackdropClick}
        className={
          " z-[9999] absolute flex items-center justify-between w-screen h-screen bg-secondary-color/50"
        }
      >
        <div className="flex-col flex items-center justify-center w-[80%] h-[40%] rounded-2xl bg-secondary-color/90 border-[2px] border-primary-color mx-[10%] bg-opaccity-50">
          <div
            role="button"
            className="w-[10%] text-xl font-bold text-right text-white relative ml-[80%] mt-[-15px] mb-4"
            onClick={handleUserClose}
            id={"btnCloseActivity"}
          >
            <MdOutlineClose size={24} />
          </div>
          <div className="text-[13px] font-bold text-white mb-5 text-center px-5">
            {translate("FULLSCREEN_USERMODAL")}{" "}
            <span className="text-primary-color">{userDetails?.username!}</span>
            ?
          </div>
          <div
            className="flex items-center justify-between w-16 h-16 overflow-hidden border-2 rounded-full border-primary-color ring-3 ring-primary-color"
            style={{
              boxShadow: "1px 1px 30px #00F3CD",
            }}
            onClick={handleGetTheApp}
          >
            <Image
              src={
                userDetails?.userThumbnail ||
                "https://avatars.mds.yandex.net/i?id=2aab3da7d6d7094ebddd1fbbb16277a0_l-5089039-images-thumbs&ref=rim&n=13&w=1080&h=1350"
              }
              className={"object-cover object-center w-full h-full"}
              style={{
                maxHeight: "100%",
                maxWidth: "100%",
              }}
              width={120}
              height={120}
              alt={""}
            />
          </div>
          <button
            onClick={handleGetTheApp}
            className="px-10  py-3 text-[12px] mt-5 font-bold tracking-wider text-black rounded-full outline-none bg-primary-color "
          >
            {translate("FOOTER_UPPER_PART2")}
          </button>
        </div>
      </div>
    </Modal>
  );
};
